import React, { useState } from 'react'
import AnOtpInput from '../../components/input_utils/AnOtpInput'
import { resend_otp, send_otp_verification } from './api'
import SelectionControl from '../../design_system/components/SelectionControls/SelectionControl'
import { Button } from '../../design_system/components/Button/Button'
import { useToast } from '../../design_system/components/Toast/ToastContext'

export const DEFAULT_OTP_LENGTH = 6
const OtpVerification = ({
    user_info = { email: '' },
    onLoginSuccess,
    ...props
}) => {
    const toast = useToast();
    const [isVerifying, setIsVerifying] = useState(false)
    const [verifyState, setVerifyState] = useState({
        otp: new Array(DEFAULT_OTP_LENGTH).fill(""),
        trustDevice: false,
        errors: {}
    })
    const { otp, trustDevice, errors } = verifyState
    const onSubmit = () => {
        if (isVerifying) return
        setIsVerifying(true)
        let data_params = { trust_device: trustDevice, email: user_info.email, otp: otp.join("") }
        send_otp_verification(data_params).then((response) => {
            setIsVerifying(false)
            onLoginSuccess(response.data)
        }).catch((error) => {
            setIsVerifying(false)
            let otp_errors = error.response?.data?.server_message || {}
            let otp_limit_error = otp_errors?.otp_attemps_exceed || otp_errors?.wrong_otp_attemps_exceed
            
            if (otp_errors?.otp_invalid) {
                toast.error(otp_errors.otp_invalid, { position: 'bottom-start' });
            }
            if (otp_limit_error) {
                toast.warning(otp_limit_error, { position: 'bottom-start' });
            }

            setVerifyState(prevState => ({ ...prevState, errors: otp_errors }))
        })
    }
    const onResend = () => {
        let data_params = { trust_device: trustDevice, email: user_info.email, otp: otp }
        resend_otp(data_params).then((response) => {

        }).catch((error) => {
            let otp_errors = error.response.data.server_message || {}
            
            if (otp_errors?.otp_attemps_exceed) {
                toast.error(otp_errors.otp_attemps_exceed, { position: 'bottom-start' });
            }

            setVerifyState({
                ...verifyState,
                errors: { ...otp_errors }
            })
        })
    }
    return (
        <div>
            <div className='login-container otp-verification text-center'>
                <div className="body-m-semibold otp-heading">
                    Please enter the verification code sent to
                </div>
                <div className="body-l-bold otp-email">{user_info.email}</div>
                <div className="otp-input-group mx-auto mt-l">
                    <AnOtpInput otp={otp} setVerifyState={(payload) => setVerifyState(prevState => ({ ...prevState, ...payload }))} onSubmit={onSubmit} errors={errors}></AnOtpInput>
                </div>
                <div className="body-m otp-resend-prompt">Didn't receive the code? <span className="link-default body-m-bold otp-resend-link cursor-pointer" onClick={() => onResend()}>Resend</span></div>
                <div className="otp-action-group mt-l w-full">
                    <Button
                        Size="Medium"
                        isLoading={isVerifying}
                        onClick={onSubmit}
                        buttonStyle={{ width: '100%' }}
                    >
                        Verify
                    </Button>
                </div>
                <div className="otp-trust-device flex justify-center items-center mt-m">
                    <SelectionControl
                        type="checkbox"
                        label="Trust This Device for 30 days"
                        checked={trustDevice}
                        onChange={() => setVerifyState({ ...verifyState, trustDevice: !trustDevice })}
                    />
                </div>
            </div>
        </div>
    )
}

export default OtpVerification
